module.exports = __webpack_public_path__ + "img/banner-left.96fff9c1.png";